import {
    SET_VALIDATION_LIST,
    UPDATE_VALIDATION_STATUS,
    ADD_ATTACHMENT,
    DELETE_ATTACHMENT,
    UPDATE_REPORT_STATUS,
    UPDATE_MEDIA_IMAGE_STATUS,
    SAVE_PERMISSION_VALIDATION,
} from "../actions/validation";
import { AnyAction } from "redux";

const initialState: any = {
    data: {},
};

const validationReducer = (state = initialState, action: AnyAction) => {
    const { type, payload } = action;
    switch (type) {
        case SET_VALIDATION_LIST:
            return {
                ...state,
                data: payload.data,
            };
        case UPDATE_REPORT_STATUS:
            return {
                ...state,
                data: {
                    ...state.data,
                    status: payload.status,
                },
            };
        case UPDATE_VALIDATION_STATUS: {
            const stepIndex = state.data.steps.findIndex(
                (item: any) => item.stepid === payload.data.step_id
            );
            const subStepIndex = state.data.steps[stepIndex].substeps.findIndex(
                (item: any) => item.id === payload.data.sub_step_id
            );

            const { id, comment, result, updatedAt, created_by } = payload.data;

            state.data.steps[stepIndex].substeps[subStepIndex] = {
                ...state.data.steps[stepIndex].substeps[subStepIndex],
                testcase_id: id,
                comment,
                result,
                tested_on: updatedAt,
                created_by,
            };

            return {
                ...state,
                data: {
                    ...state.data,
                },
            };
        }
        case ADD_ATTACHMENT: {
            const stepIndex = state.data.steps.findIndex(
                (item: any) => item.stepid === payload.step_id
            );
            const subStepIndex = state.data.steps[stepIndex].substeps.findIndex(
                (item: any) => item.id === payload.sub_step_id
            );

            payload.data.forEach((item: any) => {
                state.data.steps[stepIndex].substeps[subStepIndex].document.push({
                    id: item?.id || item?.tester_doc_id,
                    name: item.meta.name,
                    url: item.url,
                });
            });

            return {
                ...state,
                data: {
                    ...state.data,
                },
            };
        }
        case DELETE_ATTACHMENT: {
            const stepIndex = state.data.steps.findIndex(
                (item: any) => item.stepid === payload.step_id
            );
            const subStepIndex = state.data.steps[stepIndex].substeps.findIndex(
                (item: any) => item.id === payload.sub_step_id
            );

            state.data.steps[stepIndex].substeps[subStepIndex].document = state.data.steps[
                stepIndex
            ].substeps[subStepIndex].document.filter((item: any) => item.id !== payload.id);

            return {
                ...state,
                data: {
                    ...state.data,
                },
            };
        }
        case UPDATE_MEDIA_IMAGE_STATUS:
            return {
                ...state,
                itemStatus: payload.itemStatus,
            };
        case SAVE_PERMISSION_VALIDATION:
            return {
                ...state,
                savedPermissionList: payload.data,
            };
        default:
            return state;
    }
};

export default validationReducer;
